import { UserService } from '../../core/user.service';
import { Directive, TemplateRef, ViewContainerRef, Input, EmbeddedViewRef } from '@angular/core';

// tslint:disable-next-line:directive-selector
@Directive({ selector: '[permission]' })
export class PermissionDirective {
  private permissions = [];

  private viewRef: EmbeddedViewRef<any> | null = null;

  constructor(
    private templateRef: TemplateRef<any>,
    private viewContainer: ViewContainerRef,
    private userService: UserService
  ) {}

  @Input()
  set permission(permissions) {
    this.permissions = permissions;
    this.viewRef = null;
    this.updateView();
  }

  private updateView() {
    if (this.checkPermission()) {
      if (!this.viewRef) {
        this.viewContainer.clear();
        this.viewRef = this.viewContainer.createEmbeddedView(this.templateRef);
      }
    } else {
      this.viewContainer.clear();
      this.viewRef = null;
    }
  }

  private parse(
    permission: string
  ): { view: boolean; edit: boolean; resourceName: string } {
    const split = permission.split(':');

    if (split.length === 2) {
      return {
        edit: split[1] === 'edit',
        view: split[1] === 'view',
        resourceName: split[0]
      };
    }

    return {
      edit: false,
      view: true,
      resourceName: split[0]
    };
  }

  private checkPermission(): boolean {
    // if no set permission, return true
    if (!this.permissions || this.permissions.length === 0) {
      return true;
    }

    const permissions = this.userService.userInfo.permissions || [];

    for (const checkPermission of this.permissions) {
      const permission = this.parse(checkPermission);
      const hasPermission = permissions.some(
        c =>
          (c.mayView &&
            permission.view &&
            c.resourceName === permission.resourceName) ||
          (c.mayView &&
            permission.edit &&
            c.resourceName === permission.resourceName)
      );
      if (hasPermission) {
        return hasPermission;
      }
    }
    return false;
  }
}
